import ConsularModule from '@features/Consular/components/Consular.Module';

export default function Home() {
  return <ConsularModule />;
}
